<template>
  <div class="orderList">
    <!--顶部导航-->
    <Navbar title="在途订单" />
    <!--订单列表-->
    <div class="content" v-if="orderList.length !== 0">
      <!--总计待还金额-->
      <div class="totalAmount" v-if="orderList.length !== 0 && totalAmount > 0">
        <div class="left">
          <span>总待还金额(元)</span>
          <div class="totalAmount-content-amount">
            <span class="span">{{ amountFormatter(totalAmount) }}</span>
          </div>
        </div>

        <div class="right">
          <div class="right-btn" @click="handleAllRepayment">全部还清</div>
        </div>
      </div>
      <div class="order-list">
        <div
          class="list-item"
          v-for="item in orderList"
          :key="item.borrowOrderId"
        >
          <div v-if="item.planRespList.length === 0">
            <orderListItem :item="item" />
          </div>
          <div v-else>
            <repaymentStatusItem :item="item" @payAll="handlePayAll" />
          </div>
        </div>
      </div>
    </div>
    <!--选中订单金额总计-->
    <div
      class="selectedAmount"
      v-if="orderList.length !== 0 && totalAmount > 0"
    >
      <div class="selectedAmount-content">
        <div class="left">
          <span>已选金额：</span>
          <div class="selectedAmount-content-amount">
            <span>￥</span>
            <span class="span">{{ (Number(selectedAmount) + Number(serviceFee)).toFixed(2) }}</span>
          </div>
        </div>
        <div
          class="right"
          :class="{ disabled: disabled }"
          @click="handleRepaymentClick"
        >
          还款
        </div>
      </div>
    </div>
    <!--暂无数据-->
    <div v-if="orderList.length === 0 && isLoading">
      <noData
        @clickNoData="handleClickNoData"
        text="暂无订单"
        btnText="去借款"
        :img="require('@/assets/style/order-noData.png')"
      />
    </div>
    <Popup
      ref="popup1"
      message="是否确认一次性还清所有待还金额？"
      confirmText="确认结清"
      cancelText="取消"
      @confirm="handleAllRepaymentClick"
    />
    <Popup
      ref="popup"
      :message="`还款成功，当前可用额度：${remainCreditAmount}元，可用订单数：${orderCount}个，再去借一笔吧`"
      confirmText="去借款"
      cancelText="取消"
      @confirm="gotoLoan"
      :textCenter="false"
    />
    <Popup
      ref="popup2"
      @confirm="handleToOtherProduct"
      :textCenter="false"
      :message="`${blackListAd?.popContent || '资质不匹配'}`"
      :confirmText="blackListAd?.popBtnName || '去查看'"
      cancelText="取消"
      :title="blackListAd?.popTitle || '资质不匹配'"
    />
    <Popup
      ref="popup4"
      :message="`${grayListAd?.popContent?.replace('【greyDayNum】', preCheckData?.data?.greyDayNum || 'asd')}`"
      confirmText="去查看"
      cancelText="取消"
      title="资质审查中"
      @confirm="handleGrayListAd"
    />
    <Popup
      ref="popup5"
      :message="`还款成功，本次还款${repaidAmount}元，再去借一笔吧`"
      confirmText="去借款"
      cancelText="取消"
      title="还款成功"
      @confirm="handleClickNoData"
    />
    <Popup
      ref="popup6"
      :message="`当前已存在${
        preCheckData?.data?.onWayOrderNum || 0
      }笔在途订单，订单还清后可重新借款`"
      confirmText="去还款"
      cancelText="取消"
      title="超出订单上线"
      @confirm="handleUpgrade"
    />
    <Popup
      ref="popup7"
      :message="`当前剩余额度 ${homeData.remainCreditAmount}元，小于最小可借金额 ${homeData.minBorrowAmount}元，每期账单还清后，可增加最大授信额度`"
      confirmText="去提额"
      cancelText="取消"
      @confirm="handleUpgrade"
    />
    <Popup
      ref="popup8"
      message="当前暂不支持线上还款，请联系客服进行线下还款"
      confirmText="联系客服"
      cancelText="取消"
      @confirm="handleContactCustomerService"
    />
  </div>
</template>

<script>
import Navbar from "@/components/navbar/index.vue";
import orderListItem from "@/components/orderList/orderListItem.vue";
import repaymentStatusItem from "@/components/orderList/repaymentStatusItem.vue";

import {
  getOnroadBorrowOrder,
  repayment,
  preCheck,
  getSysConfigByKey,
} from "@/api/index.js";
import noData from "@/views/noData/index.vue";
import Popup from "@/components/Popup/index.vue";
import { infoErrorCode } from "@/utils/const";
import { getHomeData, getUserAllInfo } from "@/api/index.js";
import { setLocalStorageData } from "@/common/index.js";
import { amountFormatter } from "@/utils/utils";

export default {
  name: "orderList",
  components: {
    Navbar,
    orderListItem,
    repaymentStatusItem,
    noData,
    Popup
  },
  data() {
    return {
      orderList: [],
      //接口加载完成标志
      isLoading: false,
      remainCreditAmount: 0,
      orderCount: 0,
      infoErrorCode,
      //已还金额
      repaidAmount: 0,
      amountFormatter,
    };
  },
  async mounted() {
    this.initOrderList();
  },
  methods: {
    handleContactCustomerService() {
      if (process.env.VUE_APP_ENV === "productionApp") {
        this.$JSBridge.send("serviceType", { type: "8" });
      } else {
        const fromUrl = window.location.href;
        const urlTitle = document.title;
        window.open(
          `https://ykf-weixin01.7moor.com/wapchat.html?accessId=f12bce20-49ee-11f1-aea3-c5caf3f64abe&fromUrl=${fromUrl}&urlTitle=${urlTitle}&language=ZHCN`,
        );
      }
    },
    async handleAllRepayment() {
      const res = await getSysConfigByKey("REPAYMENT_MODE");
      if (res.data.configValue == 2) {
        this.$refs.popup8.showPopup();
      } else {
        this.$refs.popup1.showPopup();
      }
    },
    handleUpgrade() {},
    handleGrayListAd() {
      if(this.grayListAd.urlType == 2) return;
      if (process.env.VUE_APP_ENV === "productionApp") {
        this.$JSBridge.send("serviceType", {
          type: "10",
          url: this.grayListAd.url,
          title: this.grayListAd.name,
        });
      } else {
        window.open(this.grayListAd.url);
      }
    },
    handleToOtherProduct() {
      if(this.blackListAd.urlType == 2) return;
      //去其他产品
      if (process.env.VUE_APP_ENV === "productionApp") {
        this.$JSBridge.send("serviceType", {
          type: "10",
          url: this.blackListAd.url,
          title: this.blackListAd.name,
        });
      } else {
        window.open(this.blackListAd.url);
      }
    },
    async handleClickNoData() {
      // 贷前检测
      const preCheckRes = await preCheck({});
      this.$store.commit("setPreCheckData", preCheckRes);
      setLocalStorageData("preCheckData", preCheckRes);
      const res = await getHomeData({});
      this.$store.commit("setHomeData", res.data);
      if (infoErrorCode.includes(this.preCheckData.code)) {
        await this.getUserInfo();
        this.$toast("请先完成资质认证");
        this.$router.push({
          name: "idCardBinding",
        });
        return;
      } else if (
        this.preCheckData.code == 10004 ||
        this.preCheckData.code == 10009
      ) {
        this.$refs.popup2.showPopup();
        return;
      } else if (this.preCheckData.code == 10005) {
        this.$refs.popup4.showPopup();
        return;
      } else if (this.preCheckData.code == 10007) {
        this.$refs.popup7.showPopup();
        return;
      } else if (this.preCheckData.code == 10008) {
        this.$refs.popup6.showPopup();
        return;
      } else if (
        this.homeData.remainCreditAmount < this.homeData.minBorrowAmount
      ) {
        this.$refs.popup7.showPopup();
        return;
      } else {
        this.gotoLoan();
      }
    },
     //获取用户信息
    async getUserInfo() {
      const res = await getUserAllInfo();
      if (res.code === 2000) {
        setLocalStorageData("UserAllInfo", res.data);
      }
    },

    async handlePayAll(planRespList) {
      const REPAYMENT_MODE = await getSysConfigByKey("REPAYMENT_MODE");
      if (REPAYMENT_MODE.data.configValue == 2) {
        this.$refs.popup8.showPopup();
        return;
      }
      const res = await repayment({
        orderIssueIdList: planRespList.map((item) => item.borrowOrderIssueId),
      });
      if (res.code === 2000) {
        let PayAll = planRespList.reduce((planAcc, plan) => {
          const principalAmount = Number(plan?.principalAmount);
          const interestAmount = Number(plan?.interestAmount);
          const penaltyAmount = Number(plan?.penaltyAmount);
          return (
            planAcc +
            (Number.isFinite(principalAmount) ? principalAmount : 0) +
            (Number.isFinite(interestAmount) ? interestAmount : 0) +
            (Number.isFinite(penaltyAmount) ? penaltyAmount : 0)
          );
        }, 0);
        this.repaidAmount = PayAll.toFixed(2);
        this.orderList = [];
        this.isLoading = false;
        this.initOrderList();
        this.$refs.popup5.showPopup();
      } else {
        this.$toast(res.msg || res.message || "还款失败");
      }
    },
    async handleAllRepaymentClick() {
      const res = await repayment({
        orderIssueIdList: this.orderList.flatMap((item) =>
          item.planRespList.map((item) => item.borrowOrderIssueId),
        ),
      });
      if (res.code === 2000) {
        // 已还金额
        this.repaidAmount = this.totalAmount;
        this.isLoading = false;
        this.orderList = [];
        this.initOrderList();
        this.$refs.popup5.showPopup();
      } else {
        this.$toast(res.msg || res.message || "还款失败");
      }
    },
    async initOrderList() {
      const res = await getOnroadBorrowOrder();
      if (res.code === 2000) {
        this.isLoading = true;
        this.orderList = res.data;
        this.$store.dispatch("clearSelectedBillList");
      } else {
        this.$toast(res.msg || res.message || "获取订单列表失败");
      }
    },
    async handleRepaymentClick() {
      const REPAYMENT_MODE = await getSysConfigByKey("REPAYMENT_MODE");
      if (REPAYMENT_MODE.data.configValue == 2) {
        this.$refs.popup8.showPopup();
        return;
      }
      const selectedBillList = this.$store.state.selectedBillList;
      const serviceFeeList = this.$store.state.serviceFee;
      if (serviceFeeList.length === 0 && selectedBillList.length == 0) {
        return;
      }
      const res = await repayment({
        orderIssueIdList: selectedBillList.map(
          (item) => item.borrowOrderIssueId,
        ),
        serviveFeeOrderIds: serviceFeeList.map((item) => item.borrowOrderId),
      });
      if (res.code === 2000) {
        // 已还金额
        this.repaidAmount = Number(this.selectedAmount) + Number(this.serviceFee);
        this.isLoading = false;
        this.orderList = [];
        this.$store.dispatch("clearSelectedBillList");
        this.initOrderList();
        this.$refs.popup5.showPopup();
      } else {
        this.$toast(res.msg || res.message || "还款失败");
      }
    },
    gotoLoan() {
      this.$store.commit("setRouterFlag", "2");
      this.$router.push({
        name: "loan",
      });
    },
  },
  computed: {
    totalAmount() {
      const orders = Array.isArray(this.orderList) ? this.orderList : [];
      const total = orders.reduce((orderAcc, order) => {
      const plans = Array.isArray(order?.planRespList)
          ? order.planRespList
          : [];
        const planTotal = plans.reduce((planAcc, plan) => {
          const principalAmount = Number(plan?.principalAmount);
          const interestAmount = Number(plan?.interestAmount);
          const penaltyAmount = Number(plan?.penaltyAmount);
          const serviceFeeAmount = Number(plan?.serviceFeeAmount);
          return (
            planAcc +
            (Number.isFinite(principalAmount) ? principalAmount : 0) +
            (Number.isFinite(interestAmount) ? interestAmount : 0) +
            (Number.isFinite(penaltyAmount) ? penaltyAmount : 0) +
            (Number.isFinite(serviceFeeAmount) ? serviceFeeAmount : 0)
          );
        }, 0);
        return orderAcc + planTotal + ((order?.planRespList?.length > 0) ? Number(order?.serviceFee) : 0);
      }, 0);
      console.log(total,"total");
      return total.toFixed(2);
    },
    selectedAmount() {
      const selectedBillList = this.$store.state.selectedBillList;
      const plans = Array.isArray(selectedBillList) ? selectedBillList : [];
      const planTotal = plans.reduce((planAcc, plan) => {
        const principalAmount = Number(plan?.principalAmount);
        const interestAmount = Number(plan?.interestAmount);
        const penaltyAmount = Number(plan?.penaltyAmount);
        const serviceFeeAmount = Number(plan?.serviceFeeAmount);
        return (
          planAcc +
          (Number.isFinite(principalAmount) ? principalAmount : 0) +
          (Number.isFinite(interestAmount) ? interestAmount : 0) +
          (Number.isFinite(penaltyAmount) ? penaltyAmount : 0) +
          (Number.isFinite(serviceFeeAmount) ? serviceFeeAmount : 0)
        ) + ((plan?.serviceFee) ? Number(plan?.serviceFee) : 0);
      }, 0);
      return planTotal.toFixed(2);
    },
    serviceFee() {
      const serviceFeeList = this.$store.state.serviceFee;
      const total = serviceFeeList.reduce((acc, item) => acc + Number(item?.serviceFee), 0);
      return total.toFixed(2);
    },
    preCheckData() {
      return this.$store.state.preCheckData;
    },
    blackListAd() {
      return this.$store.state.blackListAd;
    },
    grayListAd() {
      return this.$store.state.grayListAd;
    },
    disabled() {
      return this.selectedAmount == 0 && this.serviceFee == 0;
    },
    homeData() {
      return this.$store.state.homeData;
    },
  },
};
</script>

<style scoped lang="scss">
.orderList {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: #f4f6fa;
}
.content {
  padding: 16px;
  height: 78%;
  overflow-y: auto;
}
.totalAmount {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;
  border-radius: 8px;
  background-image: url("@/assets/style/totalAmount-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #ffffff;
  .left {
    font-size: 14px;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    padding: 10px 0px;
    .totalAmount-content-amount {
      margin-top: 10px;
      .span {
        font-weight: 600;
        font-size: 28px;
        font-family: "din-bold", sans-serif;
      }
    }
  }
  .right {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .right-btn {
      font-size: 16px;
      color: #1d70f7;
      padding: 8px 12px;
      border-radius: 20px;
      background: #ffffff;
      font-weight: 600;
    }
  }
}
.selectedAmount {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0px -7px 9px 0px rgba(0, 0, 0, 0.05);
  border-radius: 12px 12px 0 0;
  .selectedAmount-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    height: 80px;
    margin: 0px 16px;
    border-radius: 12px;
    padding: 0px 10px;
    .left {
      font-size: 12px;
      display: flex;
      align-items: center;
      .selectedAmount-content-amount {
        color: #ff2e2e;
        font-weight: 600;
        font-size: 14px;
        .span {
          font-size: 20px;
        }
      }
    }
    .right {
      font-size: 18px;
      color: #ffffff;
      background: #1d70f7;
      border-radius: 30px;
      padding: 6px 30px;
    }
    .disabled {
      background: #8eb7fb;
    }
  }
}
.block {
  height: 100px;
  width: 100%;
  background: #f4f4f4;
}
</style>
